import { useEffect } from 'react';
import Root from './routes/Root';

// Tracking Tools Integrations
import Smartlook from 'smartlook-client';

export default function App() {
  useEffect(() => {
    if (import.meta.env.MODE === 'production') {
      Smartlook.init(import.meta.env.SMARTLOOK_KEY);
    }
  }, []);

  return <Root />;
}
